import { trpc } from '@/shared/api';

interface GuestPlainQuoteRequestFormQueryInput {
  readonly productId: string;
  readonly colorOptionId: string;
}

interface GuestPlainQuoteRequestFormQueryOptions {
  readonly enabled?: boolean;
}

/**
 * 비회원 일반 견적 요청 정보(quotes.getGuestPlainRequestForm, 2026-10-30 일반 견적 설계) — 비회원 견적 요청 정보와 같은 칸이고,
 * 요청 불가 문구만 디자인이 아니라 상품·색상 기준이다. 요청 불가(상품 숨김·색상 공급 불가)는 다시 물어도 같아 재시도하지 않는다.
 */
export const useGuestPlainQuoteRequestFormQuery = (
  { productId, colorOptionId }: GuestPlainQuoteRequestFormQueryInput,
  options: GuestPlainQuoteRequestFormQueryOptions = {},
) =>
  trpc.quotes.getGuestPlainRequestForm.useQuery(
    { productId, colorOptionId },
    { enabled: options.enabled ?? true, retry: false },
  );
